import {uniq} from 'lodash';

export class StringUtils {

  public static OPEN_SEC = '\u0011';
  public static CLOSE_SEC = '\u0012';
  public static REPLACE_EXPRESSION = '\u0011$1\u0012';
  public static OPEN_MARK = '<mark>';
  public static CLOSE_MARK = '</mark>';

  /**
   * Generate random GUID
   * @returns {string}
  */
  public static generateGuid(): string {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
      s4() + '-' + s4() + s4() + s4();
  }

  public static addEscapeCharacters(str: string): string {
    return str.replace(/([\[\]<>*()? |=.])/g, '\\$1');
  }

   public static isUUID ( str: string ): boolean {
    if ( !!str ) {
    const regexGuid = /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi;
    return regexGuid.test(str);
    }
    return false;
  }

  public static cleanNonNumericNonLetters(str: string): string {
    return str.replace(/[^a-zA-Z0-9]/g, '');
  }

  /** replace new line character (ASCII 10) with spaces - textbox element can't display this character */
  public static replaceNewLineCharBySpace(value: any): any {
    const LINE_FEED_CHAR_CODE = 10; // new line ASCII code
    if (value != null && typeof value === 'string') {
      return value.split(String.fromCharCode(LINE_FEED_CHAR_CODE)).join(' ');
    }

    return value;
  }

  /**
   * Replace special 'hyphen' character by very similar one: 'minus',
   * so as not to brake line splitting mechanism inside BPMN text utils
   */
  public static replaceHyphensByMinusChar(text: string) {
    const HYPHEN_CHAR = '-';
    const MINUS_CHAR = '−'; //looks very similar to hyphen, but it is different character
    return text.split(HYPHEN_CHAR).join(MINUS_CHAR);
  }

  /**
   * To add css class for any elements to identify them as a unique names
   * can be pass the label itself by calling this format method
   * which will trnaform to lowercase and replace the space with hyphen character
   */
  public static cssClassFormat(className: string) {
    const HYPHEN_CHAR = '-';
    return className.trim().toLowerCase().replace(/\s+/g, HYPHEN_CHAR);
  }

  public static escapeChevron(val: string | string[]): string {
    return val ? val.toString().replace(/</g, '&lt;'): undefined;
  }

  public static getChunks(val: string): string[] {
    const array =
        val.length > 0 ? val.toLowerCase()
            .replace(/ +/g, ',')
            .replace(/,+/g, ',')
            .split(',')
            .filter(chunk => chunk.length > 0) : [];
    return uniq(array);
  }

  public static getCountedChunks(val: string): Map<string, any> {
    let map = new Map<string, any>();
    StringUtils.getChunks(val).forEach(chunk => map.set(chunk, {number: 0, exist: false} ));
    return map;
  }

  public static getNormalizedString(val:string): string {
    const relevantChunks: string[] = val.length > 0 ? val.toLowerCase()
      .replace(/ +/g, ',')
      .replace(/,+/g, ',')
      .split(',')
      .filter(chunk => chunk.length >0) : [];
    return relevantChunks.join(',');
  }

  public static isIncluded(text: string, chunks: string[], weight: any): boolean {
    let count = 0;
    for (let idx = 0; idx < chunks.length; idx++) {
      if (text.includes(chunks[idx])) {
        weight.val += (chunks.length - idx) / (chunks.length);
        count++;
      }
    }
    weight.val += count;
    return weight.val > 0;
  }

  public static isExactIncluded(text: string, chunks: string[], weight: any): boolean {
    chunks.forEach(chunk => {
      text?.includes(chunk) ? weight.val++ : weight.val += 0;
    });
    return weight.val > 0;
  }

  public static isExactCountedIncluded(text: string, chunksMap: Map<string, any>): boolean {
    let foundSomething = false;
    let count, data;
    for (const chunk of chunksMap.keys()) {
      count = text.split(chunk).length - 1;
      if (count > 0) {
        data = chunksMap.get(chunk);
        data.number += count;
        data.exist = true;
        chunksMap.set(chunk, data);
        foundSomething = true;
      }
    }
    return foundSomething;
  }

  public static calcIsIncluded(text: string, chunks: string[], weight: any, exact:boolean = false): boolean {
    return exact ? StringUtils.isExactIncluded(text, chunks, weight) : StringUtils.isIncluded(text, chunks, weight);
  }
  /**s
  *  escapes the '<' and '>' characters
  */
  public static escapeHtml(val: string): string {
    return val ? val.toString().replace(/</g, '&lt;').replace(/>/g, '&gt;') : val;
  }

  /**
  *  Checks the file name for invalid characters
  */
  public static isInvalidCharsInFileName(fileName: string): boolean {
 /*   if (typeof fileName !== 'string') {
      return true;
    }
*/    if (fileName && fileName.length > 0) {
      const rg = /^[^\\\/:\*\?"<>\|]+$/; // forbidden characters \ / : * ? " < > |
      return !rg.test(fileName);
    }
    return true;
  }

  public static compactArray(chunks: string[]): string[] {
    if (chunks.length > 1) {
      let finalChunks = [];
      chunks = chunks.sort((a, b) => b.length - a.length);
      finalChunks.push(chunks[0]);
      chunks.forEach(chunk => {
         const res = finalChunks.some(final => final.includes(chunk));
         if(!res)
           finalChunks.push(chunk);
      });
      return finalChunks;
    }
    return chunks;
  }

  public static escapeRegExp(text:string) {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
  }

}
